// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ac54b096","455":"50b06e6c","578":"40549909","977":"88b274ea"}[chunkId] + ".chunk.js";
};